var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSquareCorner18(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.845 3.845C2.81 4.879 2.25 6.33 2.25 8h1.5c0-1.33.44-2.38 1.155-3.095C5.621 4.19 6.67 3.75 8 3.75v-1.5c-1.67 0-3.12.56-4.155 1.595z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiPjxwYXRoIGQ9Ik0zLjg0NSAzLjg0NUMyLjgxIDQuODc5IDIuMjUgNi4zMyAyLjI1IDhoMS41YzAtMS4zMy40NC0yLjM4IDEuMTU1LTMuMDk1QzUuNjIxIDQuMTkgNi42NyAzLjc1IDggMy43NXYtMS41Yy0xLjY3IDAtMy4xMi41Ni00LjE1NSAxLjU5NXoiLz48L3N2Zz4=";
export { SvgSquareCorner18 as ReactComponent };